function convertCubicMeterToLiter(num) {
  let eq =
    "Converting " +
    num +
    " cubic meter to liter: \n" +
    num +
    " * 1000 = ";
  let rep = num * 1000;
  return eq + rep.toFixed(2);
}

function convertCubicMeterToCubicYard(num) {
  let eq =
    "Converting " +
    num +
    " cubic meter to cubic yard: \n" +
    num +
    " * 1.307950619 = ";
  let rep = num * 1.307950619;
  return eq + rep.toFixed(3);
}

function convertCubicMeterToCubicMile(num) {
  let eq =
    "Converting " +
    num +
    " cubic meter to cubic mile: \n" +
    num +
    " * 2.399127586e-10 = ";
  let rep = num * 2.399127586e-10 ;
  return eq + rep.toFixed(10);
}

function convertCubicMeterToCubicInch(num) {
  let eq =
    "Converting " +
    num +
    " cubic meter to cubic inch: \n" +
    num +
    " * 61023.74409 = ";
  let rep = num * 61023.74409;
  return eq + rep.toFixed(3);
}

function convertCubicMeterToCubicFoot(num) {
  let eq =
    "Converting " +
    num +
    " cubic meter to cubic foot: \n" +
    num +
    " * 0.0005787037037 = ";
  let rep = num * 0.0005787037037;
  return eq + rep.toFixed(6);
}

export {
  convertCubicMeterToCubicFoot,
  convertCubicMeterToCubicInch,
  convertCubicMeterToCubicMile,
  convertCubicMeterToCubicYard,
  convertCubicMeterToLiter
};
